import { createSlice } from "@reduxjs/toolkit";
import { getUserNavigation } from "../actions/navigation";
import { logoutUser, loginUser, verifyEmailOtp } from "../actions/account";

const initialState = {
  error: false,
  isLoadingUserNavigation: false,
  userNavigation: [],
  urlOnLogin:null
};

const navigationSlice = createSlice({
  name: "navigation",
  initialState,
  reducers: {
    storeUrlOnLogin(state, action) {
      state.urlOnLogin = action?.payload;
    },
    "account/logoutUser": (state) => initialState,
  },
  extraReducers: {
    [getUserNavigation.pending]: (state, action) => {
      state.navigationRequestId = action.meta.requestId;
      const scope = JSON.stringify([action.meta.arg.jwt, action.meta.arg.institutionId]);
      if (state.navigationScope !== scope) state.userNavigation = [];
      state.navigationScope = scope;
      state.isLoadingUserNavigation = true;
      state.error = false;
    },
    [getUserNavigation.fulfilled]: (state, action) => {
      if (state.navigationRequestId !== action.meta.requestId) return;
      state.navigationRequestId = null;
      state.isLoadingUserNavigation = false;
      state.userNavigation = action?.payload;
      state.error = false;
    },
    [getUserNavigation.rejected]: (state, action) => {
      if (state.navigationRequestId !== action.meta.requestId) return;
      state.navigationRequestId = null;
      state.isLoadingUserNavigation = false;
      state.error = !action.meta.aborted;
    },
    [loginUser.fulfilled]: (state, action) => {
      state.userNavigation = action?.payload?.navigations;
    },
    [verifyEmailOtp.fulfilled]: (state, action) => {
      state.userNavigation = action?.payload?.navigations;
    },
    [verifyEmailOtp.rejected]: (state) => {
      state.userNavigation = initialState.userNavigation;
    },
    [logoutUser.fulfilled]: (state) => {
      return initialState
    },
    [logoutUser.rejected]: (state) => {
      return initialState
    },
  },
});

export const getError = (state) => state.navigation.error;
export const getIsLoadingUserNavigation = (state) => state.navigation.isLoadingUserNavigation;
export const getUserNavigationArray = (state) => state.navigation.userNavigation;
export const getUrlOnLogin = (state) => state.navigation.urlOnLogin;

export const {
  storeUrlOnLogin
} = navigationSlice.actions;


export default navigationSlice;
